export default ({ app, $axios, redirect, store }, inject) => {
  // 剧集详情页语义化 后端约定type -MOVIE(0, '电影') -DRAMA(1, '剧集') -SHORT_VIDEO(2, '短视频') -CARTOON(3, '动漫')
  const semanticCfg = {
    type: { 0: 'movie', 1: 'drama', 2: 'short_video', 3: 'cartoon' },
    cnName: { 0: '电影', 1: '电视剧', 2: '短视频', 3: '动漫' },
    typeId: { movie: 0, drama: 1, short_video: 2, cartoon: 3 }
  }
  inject('semantic', semanticCfg)

  app.router.beforeEach(async (to, from, next) => {
    // 详情页url语义化
    if (to.path?.includes('/detail/')) {
    }
    if (to.path?.includes('/channel/')) {
      const fromMetaTag = JSON.stringify(from?.meta)
      to.meta.menuParams = {
        type: to.params.type,
        id: to.params.id
      }
      to.meta.pageTitle = to.params.type
      to.meta.sourcePage = JSON.parse(fromMetaTag).pageTitle
    }
    next()
  })
  app.router.afterEach(async (to, from) => {
    if (process.client) {
      try {
        const res = await app.$api.getFilterParams()
        store.commit('SET_FILTER', res)
      } catch (e) {}
    }
  })
}
